import dayjs from 'dayjs'
import { CalendarCog, Check, X } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { CompactDateInput } from '@/components/ui/date-input'
import { Modal, ModalFooter } from '@/components/ui/modal'

// 出力日の一括変更ダイアログ（v1 の Modal と同じ文言・意味論: 空にすると出力日をクリアできる）。
// 開くたびに今日の日付を初期値にしたい（前回入力を持ち越さない）ため、open=false のときは
// 丸ごとアンマウントして state をリセットする（print-dialog.tsx / users-workspace.tsx と同じ対処）
export function OutputDateDialog({
  open,
  selectedCount,
  onClose,
  onConfirm,
  defaultOutputDate,
}: {
  open: boolean
  selectedCount: number
  onClose: () => void
  onConfirm: (outputDate: string | null) => void
  // 初期値の既定は「今日」。Storybook から固定日を渡せるようにしているのは、
  // 今日日付のままだと VRT のキャプチャが日をまたぐたびに差分になり baseline が不安定になるため
  defaultOutputDate?: string
}) {
  if (!open) {
    return null
  }
  return (
    <OutputDateDialogContent
      selectedCount={selectedCount}
      onClose={onClose}
      onConfirm={onConfirm}
      defaultOutputDate={defaultOutputDate}
    />
  )
}

function OutputDateDialogContent({
  selectedCount,
  onClose,
  onConfirm,
  defaultOutputDate,
}: {
  selectedCount: number
  onClose: () => void
  onConfirm: (outputDate: string | null) => void
  defaultOutputDate?: string
}) {
  const [value, setValue] = useState(() => defaultOutputDate ?? dayjs().format('YYYY-MM-DD'))

  return (
    <Modal
      title="出力日の一括変更"
      description={`選択中の${selectedCount}件の発注の出力日を一括変更します（空にすると出力日をクリアします）。`}
      icon={<CalendarCog className="size-4" />}
      onClose={onClose}
    >
      <CompactDateInput
        value={value}
        onChange={(event) => {
          setValue(event.target.value)
        }}
        aria-label="出力日"
        data-testid="steel-order-output-date-dialog-input"
        wrapperClassName="mt-3"
      />
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          <X data-icon="inline-start" />
          キャンセル
        </Button>
        <Button
          data-testid="steel-order-output-date-confirm"
          onClick={() => {
            onConfirm(value === '' ? null : value)
          }}
        >
          <Check data-icon="inline-start" />
          変更する
        </Button>
      </ModalFooter>
    </Modal>
  )
}
